import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=2d4d9164&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=js&"
export * from "./DetailList.vue?vue&type=script&lang=js&"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=2d4d9164&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d9164",
  null
  
)

export default component.exports